// react
import { ReactNode } from 'react';

// mui
import { Box, SxProps, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

// props
export interface TableInfoData {
	label: ReactNode;
	value: ReactNode;
}

export interface TableInfoProps {
	data: TableInfoData[];
}

export const TableInfo = ({ data }: TableInfoProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					backgroundColor: theme.palette.brand.grey[100],
					borderColor: theme.palette.divider,
					borderRadius: 2,
					borderStyle: 'solid',
					borderWidth: 1,
				};
			}}>
			<Table
				sx={(theme) => {
					return {
						tableLayout: 'fixed',
					};
				}}>
				<TableBody>
					{data.map((item, i) => {
						const isLast = i === data.length - 1;

						return (
							<TableRow
								key={`table-info-row-${i}`}
								sx={(theme) => {
									let sx: SxProps = {};

									if (!isLast) {
										sx = {
											...sx,
											borderBottomColor: theme.palette.divider,
											borderBottomStyle: 'solid',
											borderBottomWidth: 1,
										};
									}

									return sx;
								}}>
								<TableCell
									sx={(theme) => {
										return {
											padding: theme.spacing(1, 2),
										};
									}}>
									{typeof item.label === 'string' ? (
										<Typography fontWeight={600}>{item.label}</Typography>
									) : (
										item.label
									)}
								</TableCell>
								<TableCell
									sx={(theme) => {
										return {
											padding: theme.spacing(1, 2),
											textAlign: 'right',
										};
									}}>
									{typeof item.value === 'string' ? (
										<Typography color="brand.grey.500">{item.value}</Typography>
									) : (
										item.value
									)}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Box>
	);
};
